import {
  extend,
  customType,
  params,
  shape,
  arrayOf,
  string,
  number,
  bool
} from '@thd-nucleus/data-sources';

export const dataModel = extend(
  {
    searchModel: params({
      keyword: string(),
      storeId: string(),
      channel: customType('Channel').enum(['DESKTOP', 'MOBILE', 'TABLET'], 'DESKTOP'),
      storefilter: customType('StoreFilter').enum(['ALL', 'IN_STORE', 'ONLINE'], 'ALL')
    }).shape({
      id: string(),
      products: arrayOf({
        itemId: string(),
        identifiers: shape({
          brandName: string(),
          productLabel: string(),
          canonicalUrl: string(),
          modelNumber: string()
        }),
        media: shape({
          images: arrayOf({
            url: string(),
            sizes: string(),
            type: string(),
            subType: string()
          })
        }),
        keyProductFeatures: params().shape({
          keyProductFeaturesItems: arrayOf(shape({
            features: arrayOf(shape({
              name: string(),
              refinementId: string(),
              refinementUrl: string(),
              value: string()
            }))
          }))
        }),
        reviews: shape({
          ratingsReviews: shape({
            totalReviews: string(),
            averageRating: string()
          })
        }),
        pricing: shape({
          original: number({ float: true }),
          mapAboveOriginalPrice: bool(),
          message: string(),
          preferredPriceFlag: bool(),
          specialBuy: number({ float: true }),
          unitOfMeasure: string(),
          value: number({ float: true }),
          mapDetail: shape({
            mapPolicy: string(),
            mapSpecialPriceViolation: bool(),
            mapOriginalPriceViolation: bool(),
            percentageOff: number({ float: true }),
            dollarOff: number({ float: true })
          })
        })
      })
    }),
    product: params({
      itemId: string().isRequired()
    }).shape({
      itemId: string(),
      dataSource: string(),
      specificationGroup: arrayOf(shape({
        specTitle: string(),
        specifications: arrayOf(shape({
          specName: string(),
          specValue: string()
        }))
      })),
      identifiers: shape({
        brandName: string(),
        productLabel: string(),
        canonicalUrl: string()
      }),
      media: shape({
        images: arrayOf({
          url: string(),
          sizes: string(),
          type: string(),
          subType: string()
        })
      }),
      reviews: shape({
        ratingsReviews: shape({
          totalReviews: string(),
          averageRating: string()
        })
      }),
      pricing: shape({
        original: number({ float: true }),
        mapAboveOriginalPrice: bool(),
        message: string(),
        preferredPriceFlag: bool(),
        specialBuy: number({ float: true }),
        unitOfMeasure: string(),
        value: number({ float: true }),
        mapDetail: shape({
          mapPolicy: string(),
          mapSpecialPriceViolation: bool(),
          mapOriginalPriceViolation: bool(),
          percentageOff: number({ float: true }),
          dollarOff: number({ float: true })
        })
      })
    })
  }
);
